import { configureStore } from '@reduxjs/toolkit'
import {math,switcher,teacher} from './modules'

const store = configureStore({
  reducer: {
    math,
    switcher,
    teacher
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store